module.exports = __webpack_public_path__ + "img/ua.cf1a4bc6.svg";